import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { CatReportCreateDrawer } from '../../../../../../../../../../features/trade-reporting/cat/cat-report-create-drawer';
import { TradeReportingCatReportsTable } from '../../../../../../../../../../features/trade-reporting/cat/cat-reports-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceReporting,
      label: 'CAT',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceReporting>,
  head: () => getPageHead('CAT Reports'),
  component: CatReportList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CatReportCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New CAT Report" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingComplianceReporting}
    />
  );
}

function CatReportList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TradeReportingCatReportsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
